(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "prop-types", "react", "./FormValueScope", "./formField"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("prop-types"), require("react"), require("./FormValueScope"), require("./formField"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.react, global.FormValueScope, global.formField);
    global.IteratorField = mod.exports;
  }
})(this, function (_exports, _propTypes, _react, _FormValueScope, _formField) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = void 0;
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireDefault(_react);
  _FormValueScope = _interopRequireDefault(_FormValueScope);
  _formField = _interopRequireDefault(_formField);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

  function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

  function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

  function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

  function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

  function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

  function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

  function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  var IteratorFieldRaw =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(IteratorFieldRaw, _React$Component);

    function IteratorFieldRaw() {
      _classCallCheck(this, IteratorFieldRaw);

      return _possibleConstructorReturn(this, _getPrototypeOf(IteratorFieldRaw).apply(this, arguments));
    }

    _createClass(IteratorFieldRaw, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            value = _this$props.value,
            onChange = _this$props.onChange,
            name = _this$props.name,
            scopedName = _this$props.scopedName,
            skip = _this$props.skip,
            take = _this$props.take,
            children = _this$props.children,
            other = _objectWithoutProperties(_this$props, ["value", "onChange", "name", "scopedName", "skip", "take", "children"]);

        var items = value.skip(skip).take(take || value.count());
        return _react["default"].createElement(_FormValueScope["default"], {
          name: name
        }, _react["default"].createElement("div", other, items.map(function (item, index) {
          return _react["default"].createElement(_FormValueScope["default"], {
            key: index + skip,
            name: index + skip
          }, typeof children === 'function' ? children(item, index + skip) : children);
        })));
      }
    }]);

    return IteratorFieldRaw;
  }(_react["default"].Component);

  _defineProperty(IteratorFieldRaw, "propTypes", {
    // TODO: ImmutablePropTypes.list
    value: _propTypes["default"].any.isRequired,
    onChange: _propTypes["default"].func.isRequired,
    name: _propTypes["default"].string,
    scopedName: _propTypes["default"].string,
    skip: _propTypes["default"].number,
    take: _propTypes["default"].number,
    children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]).isRequired
  });

  _defineProperty(IteratorFieldRaw, "defaultProps", {
    skip: 0
  });

  var _default = (0, _formField["default"])()(IteratorFieldRaw);

  _exports["default"] = _default;
});